import jstz from './jstz'

Date.create = function(value, format) {
    var i, date, defaultFormats;
    if (!value) return new Date();
    if (value instanceof Date) return value; // Dates shouldn't be handled by this function
    if (typeof(value) === 'number') return moment(value).toDate();
    if (format) return moment(value, format).toDate();
    defaultFormats = [
        'YYYY-MM-DDTHH:mm:ssZ',
        'ddd MMM DD HH:mm:ss ZZ YYYY',
        'ddd, DD MMM YYYY HH:mm:ss ZZ',
        'DD/MM/YY [às] HH:mm',
        undefined           // moment.js will try to guess its format
    ];
    for (i = 0; i < defaultFormats.length; i++) {
        date = moment(value, defaultFormats[i], true);
        if (date.isValid()) return date.toDate();
    }
    return new Date(value); // Parsing of date strings with the Date constructor
                            // is strongly discouraged due to browser
};                          // differences and inconsistencies

Date.browserTimeZoneString = function() {
    return Date.create().getTimeZoneString();
};

Date.prototype.formatInTimeZone = function(timezone, format_string){
    if (format_string == undefined) {
        format_string = 'MMM DD H:mm'
    }
    if(timezone == undefined) {
        timezone = Date.browserTimeZoneString();
    }
    timezone = timezone.replace('GMT', '');
    return moment(this).zone(timezone).format(format_string);
};

Date.prototype.getTimeZoneString = function(){
    var zone = this.toString().match(/GMT\s*[+\-]\d{4}/);
    if(zone !== null){
        return zone[0];
    }
    return null;
};

Date.prototype.fromNow = function() {
    return moment(this).fromNow();
};

Date.prototype.format = function(format_string) {
    if (format_string == undefined) {
        format_string = 'MMM DD H:mm'
    }
    return moment(this).local().format(format_string);
};

// String functions
String.prototype.titleize = function() {
    var title = this.split('_');
    title = _.map(title, function(word) {return word.charAt(0).toUpperCase() + word.slice(1)});
    return title.join(' ');
};

// jQuery validator custom error handling
jQuery.validator.setDefaults({
    errorElement: "span",
    errorClass: "validation",
    highlight: function (element, errorClass, validClas) {
        $(element).parent().addClass("error");
        $(element).css('display', '');
    },
    unhighlight: function (element, errorClass, validClass) {
        $(element).parent().removeClass("error");
    },
    errorPlacement: function(error, element) {
        element.parent().append(error);
    }
});

// Set cookie with user time-zone
$.cookie('time_zone_name', jstz.determine().name());

// Handle all ajax errors
$(document).ajaxError(function(e, xhr, settings, exception) {
    if (xhr.status == 0 && xhr.statusText == 'abort') return; // 'request canceled' is ignored
    if (xhr.status == 0 && xhr.statusText == 'error') return; // js errors ignored
    if (!xhr.responseJSON) return; // jasmine tests fail without this since 91c6c62

    if (xhr.responseJSON['ticket_attribute_errors'] !== undefined) return;
    if (xhr.responseJSON['user_profile_attribute_errors'] !== undefined) return;
    if (xhr.responseJSON['reaction_error_code'] !== undefined) return;

    if (xhr.responseJSON['error'] == "AccountChanged" || xhr.responseJSON['error'] == "NewLoginDetected") return;

    if (xhr.responseJSON['message'] !== undefined) {
        showError(xhr.responseJSON['message']);
    } else {
        showError("An unexpected error has occurred. Please contact us if this error persists.");
    }
});

// NProgress bar
$(document).ajaxStart(function() {
    NProgress.start();
});
$(document).ajaxStop(function() {
    NProgress.done();
});

window.onerror = function (message, url, line_number, col_number, error) {
  var handler = new Monitoring.Methods.ErrorHandler(error);
  handler.handleWithSource(url, line_number, col_number);
  return false;
};

// Add remove to JS arrays
Array.prototype.remove = function(elem) {
    var match;

    while ((match = this.indexOf(elem)) > -1) {
        this.splice(match, 1);
    }
};

function equalHeight(group) {
    var tallest = 0;
    group.each(function() {
        var thisHeight = $(this).height();
        if(thisHeight > tallest) {
            tallest = thisHeight;
        }
    });
    group.height(tallest);
}

// $.jstree._themes = '/assets/themes/';

$.blockUI.defaults.css['background-color'] = 'transparent';
$.blockUI.defaults.css['border'] = 'none';
$.blockUI.defaults.css['top'] = '100px';
$.blockUI.defaults.message = $('<i class="fa fa-refresh fa-spin fa-3x"></i>');
$.blockUI.defaults.overlayCSS['opacity'] = 0.2;
$.blockUI.defaults.centerY = false;


window.load_popovers = function(){
  $('[rel=popover]').popover({ placement: 'top', trigger: 'hover' });
  $('[rel=popover]').removeAttr('rel');
};

window.notNull = function(variable) {
  if (_.isNaN(variable)) {
    throw 'This variable cannot be NaN';
  }
  if (_.isNull(variable)) {
    throw 'This variable cannot be null';
  }
  if (_.isUndefined(variable)) {
    throw 'This variable cannot be undefined';
  }
  return variable;
};

$(document).ready(function() {
  // Ocultar el popover al hacer clic fuera de él
  $(document).on('click', function (e) {
    if ($(e.target).data('toggle') !== 'popover' && $(e.target).parents('.popover.in').length === 0) {
      $('[data-toggle="popover"]').popover('hide');
    }
  });
});
